<div class="flex flex-col h-full w-full md:w-9/12 overflow-hidden">
	<ui-headline type="h1">{{ 'general.menu.dashboard' | translate }}</ui-headline>

	<div>
		<label class="form-label" for="search">{{ 'general.search' | translate }}</label>
		<ui-input
			inputId="search"
			[placeholder]="'general.search' | translate"
			type="search"
			[formField]="searchField"
			class="block mb-3 w-full md:w-75"
		>
		</ui-input>
	</div>

	@if (data(); as data) {
		<div class="overflow-y-auto">
			<table
				class="overflow-y-auto"
				mat-table
				[dataSource]="data"
				matSort
				[matSortActive]="sort().active"
				[matSortDirection]="sort().direction"
				(matSortChange)="onSort($event)"
				directiveMatTableResizeCols
			>
				<!-- Status Column -->
				<ng-container matColumnDef="status">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>
						<div class="mat-sort-header-content--label">
							{{ 'tests.status' | translate }}
						</div>
					</th>
					<td mat-cell *matCellDef="let element">
						<ui-icon
							[icon]="
								element.status === 'success'
									? TableIcon.success
									: element.status === 'failed'
										? TableIcon.failed
										: TableIcon.pending
							"
							size="l"
							[type]="element.status === 'failed' ? 'error' : ''"
						>
						</ui-icon>
					</td>
				</ng-container>

				<!-- IPC SN Column -->
				<ng-container matColumnDef="serialnumber">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>
						<div class="mat-sort-header-content--label">
							{{ 'tests.serial' | translate }}
						</div>
					</th>
					<td mat-cell *matCellDef="let element">{{ element.serialnumber }}</td>
				</ng-container>

				<!-- 	Date Column -->
				<ng-container matColumnDef="start">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>
						<div class="mat-sort-header-content--label">
							{{ 'tests.date' | translate }}
						</div>
					</th>
					<td mat-cell *matCellDef="let element">{{ element.start | customDate }}</td>
				</ng-container>

				<!-- 	Latest Run Column -->
				<ng-container matColumnDef="latest">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>
						<div class="mat-sort-header-content--label">
							{{ 'detail.latest' | translate }}
						</div>
					</th>
					<td mat-cell *matCellDef="let element">
						{{ element.latest | customDate }} {{ element.latest | customTime }}
					</td>
				</ng-container>

				<!-- Runs Column -->
				<ng-container matColumnDef="runs">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>
						<div class="mat-sort-header-content--label">
							{{ 'tests.runs' | translate }}
						</div>
					</th>
					<td mat-cell *matCellDef="let element">
						{{ element.runs }} / {{ element.totalRuns ?? element.runs }}
					</td>
				</ng-container>

				<ng-container matColumnDef="modemStatus">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>
						<div class="mat-sort-header-content--label">
							{{ 'tests.modemStatus' | translate }}
						</div>
					</th>
					<td mat-cell *matCellDef="let element">{{ element.modemStatus | empty }}</td>
				</ng-container>

				<ng-container matColumnDef="action">
					<th mat-header-cell *matHeaderCellDef>{{ 'tests.details' | translate }}</th>
					<td mat-cell *matCellDef="let element">
						<ui-icon
							icon="arrow_right"
							size="l"
							type="primary"
							[action]="true"
							(click)="viewDetails(element)"
							(keydown.enter)="viewDetails(element)"
							tabindex="0"
						>
						</ui-icon>
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr
					mat-row
					*matRowDef="let element; columns: displayedColumns; let i = index"
					(click)="viewDetails(element)"
					[class.is-active]="element === expandedElement()"
				></tr>
			</table>
			@if (data.filteredData.length === 0 && data.data.length > 0) {
				<ui-empty-state
					[text]="'general.no_search_result' | translate"
					class="block pt-8"
				></ui-empty-state>
			} @else if (!data.data.length) {
				<ui-empty-state [text]="'general.no_data' | translate" class="block pt-8"></ui-empty-state>
			}
		</div>
		<div class="table__paginator">
			<mat-paginator [showFirstLastButtons]="true" [hidePageSize]="true"></mat-paginator>
		</div>
	} @else {
		<ui-spinner size="l"></ui-spinner>
	}
</div>

<!-- Offcanvas Detail View -->
<selftest-detail
	[open]="!!expandedElement()"
	[element]="expandedElement()"
	(closeDetails)="closeDetails()"
></selftest-detail>
